// Hook: PUT /company/locations/{id} - aktualizacja lokacji

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IRequest {
  name?: string;
  city?: string;
  address?: string;
  postal_code?: string;
  country?: string;
  phone?: string | null;
  is_headquarters?: boolean;
}

export interface IVariables {
  id: number;
  data: IRequest;
}

type IResponse = ICommandResponseSuccess;

const putCompanyLocation = (id: number, data: IRequest): Promise<IResponse> =>
  axios.put(`/company/locations/${id}`, data);

export const usePutCompanyLocation = (
  options?: UseMutationOptions<IResponse, IError, IVariables>
) =>
  useMutation(({ id, data }: IVariables) => putCompanyLocation(id, data), options);
